const ParseFloatPayment = (value: any): number => {
  return parseFloat(Number(value || 0).toFixed(2));
};

export default ParseFloatPayment;
